<template>
  <div class="container-fluid">
    <dashboard-verify-email-alert
      v-if="$userIsUnverified"/>

    <div class="dashboard-block" v-if="$paymentsModuleEnabled">
      <h2 class="has-button">
        Upcoming Payments
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoUpcomingPayments">
        You have no upcoming payments.
      </div>
      <ul v-else class="item-detail list-links item-detail-price">
        <client-dashboard-upcoming-payments-list-item
          v-for="payment in payments"
          :key="payment.id"
          :payment="payment"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'payments.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>
    <div class="dashboard-block" v-if="$chatsModuleEnabled && !haveNoActiveThreads">
      <h2 class="has-button">
        Active Chats
        &ndash;
        {{ lists.active_threads_count }}
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoActiveThreads">
        There are no active chats
      </div>
      <ul v-else class="list-items">
        <thread-list-item
          v-for="thread in activeThreads"
          :key="thread.id"
          :thread="thread"
          :booking="thread.booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'threads.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>

    <div class="dashboard-block" v-if="!haveNoBookingRequests">
      <h2 class="has-button">
        {{ $t('Booking Requests') }}
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoBookingRequests">
        You have no {{ $t('booking requests') }}.
      </div>
      <ul v-else class="list-items">
        <client-dashboard-booking-requests-list-item
          v-for="booking in requests"
          :key="booking.id"
          :booking="booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'requests.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>

    <div class="dashboard-block" v-if="!haveNoBookings">
      <h2 class="has-button">
        Booked Events
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoBookings">
        You have no booked events.
      </div>
      <ul v-else class="list-items">
        <client-dashboard-booking-list-item
          v-for="booking in bookings"
          :key="booking.id"
          :booking="booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'bookings.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DashboardVerifyEmailAlert from './DashboardVerifyEmailAlert'
import ClientDashboardBookingRequestsListItem from './ClientDashboardBookingRequestsListItem'
import ClientDashboardUpcomingPaymentsListItem from './ClientDashboardUpcomingPaymentsListItem'
import ClientDashboardBookingListItem from './ClientDashboardBookingListItem'
import ThreadListItem from '../message/ThreadListItem'

export default {
  components: {
    DashboardVerifyEmailAlert,
    ClientDashboardBookingRequestsListItem,
    ClientDashboardUpcomingPaymentsListItem,
    ClientDashboardBookingListItem,
    ThreadListItem
  },

  computed: {
    ...mapState('dashboard', ['lists']),

    activeThreads () {
      return this.lists.active_threads || []
    },

    requests () {
      return this.lists.requests || []
    },

    bookings () {
      return this.lists.bookings || []
    },

    payments () {
      return this.lists.payments || []
    },

    haveNoActiveThreads () {
      return this.lists.active_threads === undefined ||
        this.lists.active_threads.length === 0
    },

    haveNoBookingRequests () {
      return this.lists.requests === undefined ||
        this.lists.requests.length === 0
    },

    haveNoUpcomingPayments () {
      return this.lists.payments === undefined ||
        this.lists.payments.length === 0
    },

    haveNoBookings () {
      return this.lists.bookings === undefined ||
        this.lists.bookings.length === 0
    }
  }
}
</script>
